module.exports = __webpack_public_path__ + "img/partner_img29.6fce5df0.png";